/** Visual-viewport geometry shared by the desktop frame and mobile fixed controls. */
export const KEYBOARD_HEIGHT_DEFICIT_PX = 120;

export interface ViewportLiftInput {
  windowInnerHeight: number;
  visualViewportHeight: number;
  visualViewportOffsetTop: number;
  visualViewportScale: number;
}

export interface ViewportLiftState {
  height: number;
  offset: number;
  bottomInset: number;
  compact: boolean;
}

export const IDLE_VIEWPORT_LIFT: ViewportLiftState = {
  height: 0,
  offset: 0,
  bottomInset: 0,
  compact: false,
};

export interface StageViewportVariables {
  '--stage-viewport-height'?: string;
  '--stage-viewport-transform'?: string;
  '--stage-keyboard-inset'?: string;
  '--stage-visual-top'?: string;
}

export function resolveViewportLift(input: ViewportLiftInput): ViewportLiftState {
  if (!Object.values(input).every(Number.isFinite) || input.visualViewportHeight <= 0) {
    return IDLE_VIEWPORT_LIFT;
  }
  const heightDeficit = input.windowInnerHeight - input.visualViewportHeight;
  // Retain native pinch-zoom/panning and ignore small browser-toolbar resizes.
  if (heightDeficit < KEYBOARD_HEIGHT_DEFICIT_PX || input.visualViewportScale !== 1) {
    return IDLE_VIEWPORT_LIFT;
  }
  const offset = Math.min(heightDeficit, Math.max(0, input.visualViewportOffsetTop));
  return {
    height: input.visualViewportHeight,
    offset,
    bottomInset: heightDeficit - offset,
    compact: true,
  };
}

export function viewportLiftVariables(state: ViewportLiftState): StageViewportVariables {
  if (!state.compact) {
    return {};
  }
  return {
    '--stage-viewport-height': `${state.height}px`,
    '--stage-viewport-transform': `translateY(${state.offset}px)`,
    '--stage-keyboard-inset': `${state.bottomInset}px`,
    '--stage-visual-top': `${state.offset}px`,
  };
}
